import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { clubOnBoardingStages } from '@/pages/club/onboard/ClubOnBoarding';

const validateParams = z.object({
  step: clubOnBoardingStages
});
const validateSearch = z.object({
  from: z.string().optional()
});

export const Route = createFileRoute('/clubOwner/$id/_onboard/onboard/$step')({
  params: validateParams,
  validateSearch
});
